<template>
  <div>
    <img class="logo" src="@/assets/images/header-banner.png" alt="">
        <div class="grid">
          <div class="grid">
            <div class="grid-item phone-num">
              <dl class="input-list">
                <dt>▶ 기프티엘 쿠폰 환불 안내</dt>
                <img class="img" src="@/assets/images/img.png" alt="">
                    <dd>- 유효기간 만료 전 환불은 롯데잇츠에서 직접 가능(환불하기 버튼 이용)</dd>
                    <dd>- 유효기간 만료 후 환불은 기프티엘 고객센터로 문의(고객센터:1644-4276)</dd>
                    <dd>- 휴대폰 소액 결제 건은 구매 당월까지 롯데잇츠에서 직접 환불 가능하며, 익월부터는 기프티엘 고객센터로 문의</dd>
                    <dd>- 쿠폰 구매자와 수신자가 다르거나, 롯데잇츠 앱이 없을 경우 기프티엘 고객센터로 문의</dd>
                    <dd>- 기타 구독 쿠폰 문의: 1522-2552</dd>
                    <br>
                <dt>▶ 환불조건</dt>
                <img class="img" src="@/assets/images/img.png" alt="">
                    <dd>- 최초 유효기간 경과 전: 구매금액의 100%에 대해 환불</dd>
                    <dd>- 최초 유효기간 경과 후: 구매금액의 90%에 대해 환불</dd>
                    <dd>- 금액권은 최초 유효기간 경과 전에는 권면가액의 100분의 60(1만원권 이하 100분의 80)이상 사용 시 환불 신청 가능</dd>
                    <dd>- 유효기간 시작일로부터 5년(1,825일)이 경과한 상품은 환불 제한</dd>
                    <dd>- 구매 시 할인율은 공제되고 환불 될 예정</dd>
                    <br>
                <dt>▶ 유효기간 연장 정책</dt>
                <img class="img" src="@/assets/images/img.png" alt="">
                    <dd>- 정상 구매가 상품: 최초 유효기간은 1년(366일)으로 최초 유효기간 종료 전 요청 시 유효기간 연장은 1회 3개월(93일) 단위로 연장 가능하며, 최대 5년까지 연장 가능</dd>
                    <dd>-프로모션 할인 구매가 상품: 유효기간 연장 불가</dd>
            </dl>
          </div>
        </div>
        </div>
  </div>
</template>
<script>
/* eslint-disable */
import Header from '@/components/Header';
import Stepper from '@/components/Stepper';


export default{
  name: "FyiRefund",
  components: {
    Header,
    Stepper
  },
  }
;
</script>

<style scoped lang='scss'>
@import '@/assets/styles/mixin.scss';
@import '@/assets/styles/contents.scss';

.logo{
  text-align: center;
  width: 100%;
  // background-position: 300% 300%;
  // margin-left: 100px;
  }
.img{
  // text-align: center;
  width: 180px;
  // top: 200px;
  position: relative;
  // background-position: 100px 100px;
  // height: 100%;
  // padding-bottom: 100px;
  top:-10px
  // transform: translate(0, 0,100px);
  }


 .grid {
    .grid-item {
      background: #fff;
    }
    .phone-num {
      padding: 20px;
      line-height: 20px;

      .input-list {
        dt {
          font-weight: 900;
          font-size: 17px
        }
        dd {
          // bottom: 101px;
          font-size: 13px;
           margin-top: -10px;
        }
        dd + dd {
          margin-top: 5px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/FyiRefund.vue